import Typography from '@mui/material/Typography';
import Link from '@fuse/core/Link';
import Paper from '@mui/material/Paper';
import AuthJsForm from '@auth/forms/AuthJsForm';
// Image - use regular img tag

/**
 * The sign up page.
 */
function SignUpPage() {
	return (
		<div className="flex min-w-0 h-screen flex-col items-center justify-center">
			<Paper className="bg-white w-full rounded-none px-4 py-8 sm:min-h-auto sm:w-auto sm:rounded-xl sm:p-12 sm:shadow-sm">
				<div className="mx-auto w-full max-w-120 sm:mx-0 sm:w-120 flex flex-col items-center">
					<img
						src="/assets/images/logo/logo_loanapp.png"
						alt="ASSETS ID"
						width={165}
						height={70}
					/>

					<div className="w-full">
						<Typography className="mt-8 text-4xl font-extrabold leading-[1.25] tracking-tight">
							Sign up
						</Typography>
						<div className="mt-0.5 flex items-baseline font-medium">
							<Typography>Already have an account?</Typography>
							<Link
								className="ml-1"
								to="/sign-in"
							>
								Sign in
							</Link>
						</div>

						<AuthJsForm formType="signup" />
					</div>
				</div>
			</Paper>
		</div>
	);
}

export default SignUpPage;
